import styled from 'styled-components';

export const DetailList = styled.ul`
  font-size: 18px;
  margin-left: 50px;
  @media (max-width: 480px){
    font-size: 14px;
  }
  @media (max-width: 660px){
    margin-left: 0;
  }
  li:first-child {
   padding-top: 0;
}
  li {
    padding: 10px 0;
    border-bottom: 1px solid #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;

    span {
      font-weight: 700;
    }
  }
`;

export const InstitutionsList = styled.ul`
  color: #fff;
  li {
    border-bottom: 1px solid #fff;
    padding: 10px 0;
  }

  h3 {
    font-size: 18px;
    text-align: left;
    color: #fff;
    transition: all .25s linear;

    &:hover {
      color: #edbd2f;
    }
  }
  p {
    color: #fff;
    margin-top: 5px;
    font-weight: 300;
  }
  a {
    text-align: left;
  }
`;

export const SelectInstWrapper = styled.div`
  width: 20%;
  display: flex;
  flex-direction: column;

  &:nth-child(2){
    // margin: 12px 10px 0 10px;
    margin-left: 10px;

    @media (max-width: 1300px){
      margin-right: 10px;
      min-width: 260px;
    }
    @media (max-width: 600px){
      margin-left: 0;
    }
  }
`;

export const Divider = styled.div`
  margin-top: 60px;
`;

export const SmallDivider = styled.div`
  margin-top: 20px;

  @media (max-width: 480px) {
    margin-top: -20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  input {
    min-width: 300px;
  }
`;

export const SelectLevel = styled.div`
    margin-left: 10px;
`;

export const Image = styled.div`
  text-align: center;

  img {
    max-width: 300px;
  }
`;

export const DetailInfoWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  alingn-items: center;

  @media (max-width: 660px){
    flex-direction: column;
  }
  
  img {
  min-width: 200px;
  max-width: 300px;
  @media (max-width: 660px){
    margin-bottom: 20px;
  }
  }
`;

export const TimeList = styled.ul`
  display: flex;
  flex-flow: row wrap;
`;

export const TimeItem = styled.li`
  padding: 10px;
  cursor: ${props => props.open ? "pointer" : "not-allowed"};
  border: 1px solid ${props => props.open ? "#fff" : "#edbd2f"};
  margin: 15px 30px 15px 0;
  border-radius: 4px;
  color: ${props => props.open ? "#fff" : "#edbd2f"};
  transition: all .25s ease;

  &:hover {
    background-color: rgba(255, 255, 255, .2)
}
`;



// WEBPACK FOOTER //
// ./src/system/main/institutions/components.js